<template>
    <div class="address-details">
        <div v-if="location.openingTimes" class="opening-times">
            <div class="headline">
                {{ translate(translations, 'location.openingtimes') }}
            </div>
            <span v-html="location.openingTimes"/>
        </div>

        <div v-if="location.paymentMethods.length" class="payment-methods">
            <div class="headline">
                {{ translate(translations, 'location.paymentmethods') }}
            </div>
            <ul>
                <li v-for="(paymentMethod, index) in location.paymentMethods" :key="index">
                    {{ paymentMethod }}
                </li>
            </ul>
        </div>

        <div v-if="location.trashTypes.length" class="trash-types">
            <div class="headline">
                {{ translate(translations, 'location.trashtypes') }}
            </div>
            <ul>
                <li v-for="(trashType, index) in location.trashTypes" :key="index">
                    {{ trashType }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { translate } from '../translate';

export default {
	name: 'LocationAccordionBody',
	props: {
		location: {
			type: Object,
			required: true,
		},
		translations: {
			type: Object,
			required: true,
		},
	},

	setup(props) {
		return {
			// eslint-disable-next-line vue/no-dupe-keys
			location: props.location,
			translate,
		};
	},
};
</script>
